import classNames from 'classnames'

import Text, { TextSizes } from '~/components/atoms/Text/Text'

import styles from './NumberedCircle.module.css'

export interface NumberedCircleProps {
  number: string
  className?: string
  testID?: string
}

export default function NumberedCircle({
  number,
  className,
  testID,
}: NumberedCircleProps) {
  return (
    <div className={classNames(styles.base, className)} data-testid={testID}>
      <Text className={styles.number} size={TextSizes.primaryTitleMed}>
        {number}
      </Text>
    </div>
  )
}
